import type { Theme } from '@mui/material';
import type { PieLabelRenderProps } from 'recharts';

export const PIE_COLORS = [
    '#3b82f6',
    '#10b981',
    '#f59e0b',
    '#ef4444',
    '#8b5cf6',
    '#06b6d4',
    '#84cc16',
    '#f97316',
];

export const renderPieLabel = ({ name, percent }: PieLabelRenderProps) =>
    `${name ?? ''} ${(((percent as number) ?? 0) * 100).toFixed(0)}%`;

export const makeTooltipStyle = (theme: Theme) => ({
    contentStyle: {
        background: theme.palette.background.paper,
        border: `1px solid ${theme.palette.divider}`,
        borderRadius: 8,
        color: theme.palette.text.primary,
    },
    labelStyle: { color: theme.palette.text.secondary },
});
